import React from 'react'
import { Switch, Route, Redirect, useParams, useHistory, useLocation } from 'react-router-dom'
import { withNavigation } from 'hocs'
import { BaseRouteParams, WithNavigationProps } from 'hocs'
import { Container, FullWidthContainerBody } from 'uiComponents/settingsContainer'
import DiscountsSectionTabs from 'discounts/sectionTabs'
import { NavigationBack } from 'uiComponents/navigation/navigationBack'
import InSectionTabsSlot from 'uiComponents/navigation/sectionTabsSlot'
import './styles.scss'
import DiscountRulesList from 'discounts/rules/table/list'
import DiscountRuleDetails from 'discounts/rules/form'
import MetadataContextState from './metadataContext'
import DiscountRulesContextState from './table/tableContext'
import RulesFormContextState from './form/formContext'
import { useMessages } from 'messagesContext'
import { PageAddButton } from 'uiComponents/buttons/pageAddButton'
import { useTranslation } from 'translations'

interface DiscountRulesContainerProps extends WithNavigationProps<BaseRouteParams> {}

function DiscountRulesContainer(props: DiscountRulesContainerProps) {
    const { t } = useTranslation()
    const { replaceMessages } = useMessages()
    const { accountSlug } = useParams<BaseRouteParams>()
    const history = useHistory()
    const location = useLocation()

    const isListPage = location.pathname.includes('/home')

    return (
        <div style={{ position: 'relative' }}>
            {isListPage ? (
                <DiscountsSectionTabs />
            ) : (
                <InSectionTabsSlot>
                    <div className="detail-page-back">
                        <NavigationBack
                            onClick={() => history.push(`/account/${accountSlug}/discounts/rules/home`)}
                            text="Back to discount rules"
                        />
                    </div>
                </InSectionTabsSlot>
            )}
            <div className="discount-rules-table-header">
                {isListPage && (
                    <PageAddButton to={`/account/${accountSlug}/discounts/rules/details/new`}>
                        {t('products.discountRules.addNew')}
                    </PageAddButton>
                )}
            </div>
            <Container>
                <MetadataContextState
                    match={props.match}
                    navigation={props.navigation}
                    history={history}
                    replaceMessages={replaceMessages}
                >
                    <Switch location={location}>
                        <Route
                            path="/account/:accountSlug/discounts/rules/home"
                            render={() => (
                                <FullWidthContainerBody>
                                    <DiscountRulesContextState>
                                        <DiscountRulesList />
                                    </DiscountRulesContextState>
                                </FullWidthContainerBody>
                            )}
                        />
                        <Route
                            path="/account/:accountSlug/discounts/rules/details/:ruleId"
                            render={() => (
                                <FullWidthContainerBody>
                                    <RulesFormContextState>
                                        <DiscountRuleDetails />
                                    </RulesFormContextState>
                                </FullWidthContainerBody>
                            )}
                        />
                        <Route render={() => <Redirect to={`/account/${accountSlug}/discounts/rules/home`} />} />
                    </Switch>
                </MetadataContextState>
            </Container>
        </div>
    )
}

export default withNavigation(DiscountRulesContainer)
